<app-site-settings-menu>
    <mat-card *ngIf="hasFeatureAccess">
        <mat-card-title class="header">
            <h5 appLocalizationPopupDirective localizationCode="Positions">{{ 'Positions' | translate: {Default: "Positions"} }}</h5>
            <div>
                <button mat-stroked-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="redirectOrgChart()" class="k-mr-3" *appHasFeature="features.POSITIONS_REPORT">
                    {{ 'Positions-ShowPositionChart' | translate: {Default: "Show Position Chart"} }}
                </button>
                <button mat-flat-button setColor="primaryColour" color="primary" routerLink="{{routes.SITE_SETTINGS}}/{{routes.POSITIONS}}{{routes.EDITOR}}">
                    <mat-icon aria-hidden="false" class="material-icons-outlined" aria-label="add icon">add</mat-icon> {{ 'Positions-CreateNewPosition' | translate: {Default: "Create New Position"} }}
                </button>
            </div>
        </mat-card-title>
        <mat-card-content>
            <app-data-grid-comp
                *ngIf="hasFeatureAccess"
                [gridId]="gridId"
                [columns]="columns"
                [sort]="sort"
                [sortString]="sortString"
                [sortableColumns]="sortableColumns"
                [sortable]="{
                    mode: 'multiple'
                }"
                [tableId]="db_tables.Positions"
                [gridDataResult]="gridDataResult"
                [isLoading]="isLoading"
                [pageSize]="pageSize"
                [skip]="skip"
                [rowSelectionSettings]="{
                    canSelectRows: true,
                    selectableMode: 'multiple',
                    selectRowBy: 'id'
                }"
                clickableRows="true"
                searchable="true"
                hideActionButtons="true"
                [filterCategories]="filterCategories"
                [clearSelectedItems]="clearSelectedItems"
                [rowActionButtons]="gridActionButtons"
                [filterToggleDetails]="filterToggleDetails"
                (emitOpenDialogEvent)="navigateToPosition($event)"
                (emitDeleteEvent)="deleteAllSelected($event)"
                (rowActionEvent)="openConfirmationDialog($event)"
                (emitGridStateChangeEvent)="gridStateChange($event)"
            ></app-data-grid-comp>
        </mat-card-content>
    </mat-card>

    <no-feature-access *ngIf="!hasFeatureAccess"></no-feature-access>
</app-site-settings-menu>
